import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { authConfig } from '../../config/auth.config';
import { SharedService } from './shared.service';
import { KcgService } from './kcg.service';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { filter, map } from 'rxjs/operators';
import { BehaviorSubject, ReplaySubject, combineLatest, Observable, Subscription } from 'rxjs';
import { KModalService } from 'ng-k-modal';
import { TimeoutService } from './timeout.service';

@Injectable({
  providedIn: 'root'
})
export class OauthPlusService {
  private _routerSub = Subscription.EMPTY;
  basicUserData: any;

  //public subscriptions: Subscription[] = [];
  currentUrlPath: string = '';
  private isAuthenticatedSubject$ = new BehaviorSubject<boolean>(false);
  // public isAuthenticated$ = this.isAuthenticatedSubject$.asObservable();
  public $whenUserLoaded = this.isAuthenticatedSubject$.asObservable();

  private isDoneLoadingSubject$ = new ReplaySubject<boolean>();
  public isDoneLoading$ = this.isDoneLoadingSubject$.asObservable();

  public canActivateProtectedRoutes$: Observable<boolean> = combineLatest(
    this.$whenUserLoaded,
    this.isDoneLoading$
  ).pipe(map(values => values.every(b => b)));

  constructor(
    private oauthService: OAuthService,
    private router: Router,
    private store: SharedService,
    private kcgService: KcgService,
    private modalService: KModalService,
    private timeoutService: TimeoutService
  ) {
  }


  public async configure() {
    await this.getCurrentPath();
    let currentUrlPath = this.currentUrlPath;

    this.oauthService.configure(authConfig);    
    this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    this.oauthService.loadDiscoveryDocumentAndTryLogin({
      onTokenReceived: async (context) => {
        //Redirect to specific page
        if (context.state) {
          this.router.navigateByUrl(context.state);
        }
      }
    }).then(hasReceivedTokens => {
      if (!hasReceivedTokens) {
        this.oauthService.initLoginFlow(currentUrlPath);
      } else {
        // this.authService.storage.setItem(`oidc.user:${environment.KcgIssuer}:${environment.KcgClientID}`,JSON.stringify({access_token: this.authService.getAccessToken()}))
        // this.authService.fireEventUserSessionStart();
        this.store.setOnUserLogged(true);
        this.store.setUserDetails(this.oauthService.getIdentityClaims());
        this.isDoneLoadingSubject$.next(true);
      }
    });

    this.oauthService.setupAutomaticSilentRefresh();

    this.oauthService.events.subscribe(({ type }: any) => {
      if (type === 'token_received') {
        console.log('New token received after silent refresh')
        this.isAuthenticatedSubject$.next(this.oauthService.hasValidAccessToken());
        this.store.dispatchEvent('token:refreshed');
        this.oauthService.loadUserProfile();
      }
      if (type === 'invalid_nonce_in_state') {
        console.log('invalid_nonce_in_state');
        if(!this.timeoutService.getTimeoutModalIsOpen() || !this.modalService.getIsOpen("renewTokenFailed")){
          this.modalService.setIsOpen("renewTokenFailed", true);
        }
      }
      if(type === 'silent_refresh_timeout'){
        console.log('silent_refresh_timeout');
        // if(!this.timeoutService.getTimeoutModalIsOpen() || !this.modalService.getIsOpen("renewTokenFailed")){
        //   this.modalService.setIsOpen("renewTokenFailed", true);
        // }
      }
    },
   (err: any) => {
     console.log(err)
   });
  }

  public setObservablesOntoken(){
    if(!this.oauthService.hasValidAccessToken()){
      this.isAuthenticatedSubject$.next(false);
      this.isDoneLoadingSubject$.next(false)
    }
  }

  getCurrentPath() {
    this._routerSub = this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        this.currentUrlPath = event.url;
      }
    })
  }

  async getKcgUserBasic() {
    try {
      if (this.basicUserData) return this.basicUserData;
      const basicUserData = await this.kcgService.basicUserAuthorization().toPromise();
      this.basicUserData = basicUserData.data;
      return this.basicUserData;
    } catch (ex) {
      return null;
    }
  }

}

















